<template>
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" width="840px" top="6vh">
        <el-form v-if="!!detailModel" ref="form" :model="detailModel.data" :label-width="labelWidthMap[detailModel.type] || '90px'">
            <!-- 编辑审批节点 -->
            <template v-if="detailModel.type === 'approval-node'">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>基础信息</span>
                    </div>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="名称" prop="label" :rules="formRulesMap.label">
                                <el-input v-model="detailModel.data.label"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="审批方式" prop="checkMethod" :rules="formRulesMap.checkMethod">
                                <el-radio-group v-model="detailModel.data.checkMethod">
                                    <el-radio
                                        v-for="item in checkMethodOptions"
                                        :key="item.value"
                                        :label="item.value">
                                        {{item.label}}
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="审批人重复" prop="sameApprover" :rules="formRulesMap.sameApprover">
                                <el-radio-group v-model="detailModel.data.sameApprover">
                                    <el-radio
                                        v-for="item in sameApproverOptions"
                                        :key="item.value"
                                        :label="item.value">
                                        {{item.label}}
                                    </el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="备注" prop="remark">
                                <el-input v-model="detailModel.data.remark" type="textarea" :autosize="{ minRows: 3, maxRows: 5}" maxlength="500"
                                          show-word-limit/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card class="box-card" style="margin-top: 16px;">
                    <div slot="header" class="clearfix">
                        <span>审批人</span><span style="margin-left: 10px;color: green;">审批人为表格中所有行对应员工的并集</span>
                    </div>
                    <el-table
                        border
                        :data="detailModel.data.approvalData"
                        style="width: 100%">
                        <el-table-column
                            label="类型"
                            prop="typeName"
                            width="100">
                        </el-table-column>
                        <el-table-column
                            label="成员">
                            <template slot-scope="scope">
                                <el-form-item :prop="'approvalData.' + scope.$index + '.approvalValue'" label-width="10px" style="margin-bottom: 0">
                                    <el-select multiple v-model="scope.row.approvalValue" placeholder="请选择" style="width: 100%">
                                        <el-option
                                            v-for="item in approvalTypeList[scope.row.type]"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </template>
            <!-- 编辑经办节点 -->
            <template v-else-if="detailModel.type === 'handle-node'">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="名称" prop="label" :rules="formRulesMap.label">
                            <el-input v-model="detailModel.data.label"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="处理事项" prop="handleType" :rules="formRulesMap.handleType">
                            <el-select v-model="detailModel.data.handleType" placeholder="请选择" style="width: 100%;">
                                <el-option
                                    v-for="item in handleTypeOptions"
                                    :key="item.type"
                                    :label="item.name"
                                    :value="item.type">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="备注" prop="remark">
                            <el-input v-model="detailModel.data.remark" type="textarea" :autosize="{ minRows: 3, maxRows: 5}" maxlength="500"
                                      show-word-limit/>
                        </el-form-item>
                    </el-col>
                </el-row>
            </template>
            <!-- 编辑分支条件 -->
            <template v-else-if="detailModel.type === 'edge'">
                <el-button type="primary" icon="el-icon-plus" size="small" @click="addCondition"
                           style="margin: 0 0 10px 0;float: right;" :disabled="detailModel.data.conditionData.length > 9">添加</el-button>
                <el-table
                    border
                    :data="detailModel.data.conditionData"
                    style="margin: 10px 0;height: 48vh;overflow-y: scroll">
                    <el-table-column
                        label="关联逻辑"
                        prop="link"
                        width="110">
                        <template slot-scope="scope">
                            <el-form-item :prop="'link'" v-if="scope.$index > 0" style="margin-bottom: 0">
                                <el-select v-model="scope.row.link" placeholder="请选择" style="width: 100%" @change="calcPreviewCondition">
                                    <el-option
                                        v-for="item in judgeConditionMap.link"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="("
                        width="40">
                        <template slot-scope="scope">
                            <el-form-item :prop="'leftParenthesis'" style="margin-bottom: 0">
                                <el-checkbox v-model="scope.row.leftParenthesis" @change="calcPreviewCondition"></el-checkbox>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="字段"
                        width="180">
                        <template slot-scope="scope">
                            <el-form-item :prop="'field'" style="margin-bottom: 0">
                                <el-select v-model="scope.row.field" placeholder="请选择" style="width: 100%"
                                           @change="((val)=>{onConditionFieldChange(val, scope.$index)})">
                                    <el-option
                                        v-for="item in fieldList"
                                        :key="item.paramName"
                                        :label="item.paramKey"
                                        :value="item.paramName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="条件"
                        width="159">
                        <template slot-scope="scope">
                            <transition>
                                <el-form-item :prop="'condition'" v-if="scope.row.judgeCondition != null && scope.row.judgeCondition instanceof Array" style="margin-bottom: 0">
                                    <el-select v-model="scope.row.condition" placeholder="请选择" style="width: 100%" @change="calcPreviewCondition">
                                        <el-option
                                            v-for="item in scope.row.judgeCondition"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <span v-else>{{scope.row.condition}}</span>
                            </transition>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="比较对象"
                        width="180">
                        <template slot-scope="scope">
                            <el-form-item :prop="'compareObj'" style="margin-bottom: 0">
                                <el-select v-model="scope.row.compareObj" placeholder="请选择" style="width: 100%"
                                           @change="calcPreviewCondition"
                                           v-if="scope.row.compareOptions !=null && scope.row.compareOptions instanceof Array" :multiple="scope.row.compareOptionsMulti">
                                    <el-option
                                        v-for="item in scope.row.compareOptions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                                <el-input v-model="scope.row.compareObj" @keydown.native="handleInput" v-else></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label=")"
                        width="40">
                        <template slot-scope="scope">
                            <el-form-item :prop="'rightParenthesis'" style="margin-bottom: 0">
                                <el-checkbox v-model="scope.row.rightParenthesis" @change="calcPreviewCondition"></el-checkbox>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        prop="action"
                        width="50">
                        <template slot-scope="scope">
                            <i class="el-icon-remove-outline" v-if="scope.$index > 0" @click="removeCondition(scope.$index)"></i>
                        </template>
                    </el-table-column>
                </el-table>
                <el-alert
                    title="条件预览"
                    :description="str"
                    type="error"
                    :closable="false">
                </el-alert>
            </template>
            <!-- 编辑判定节点 -->
            <template v-else>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="名称" prop="label" :rules="formRulesMap.label">
                            <el-input v-model="detailModel.data.label"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="备注" prop="remark">
                            <el-input v-model="detailModel.data.remark" type="textarea" :autosize="{ minRows: 3, maxRows: 5}" maxlength="500"
                                      show-word-limit/>
                        </el-form-item>
                    </el-col>
                </el-row>
            </template>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {departmentOrg, flowDefEnums, flowDefParamList, getRolesList, getUserList} from './api/table'

    import {set} from './utils'

    const Ele = window.ELEMENT;

    export default {
        name: "flow-editor-model",
        props: {
            value: {type: Boolean},
            detailModel: {type: Object, require: true},
        },
        watch: {
            value(val) {
                this.dialogFormVisible = val
                if (!!val) {
                    this.$nextTick(() => {
                        this.refresh()
                    })
                }
            },
        },
        data() {
            return {
                dialogFormVisible: this.value,
                checkMethodOptions: [
                    {
                        label: '或签',
                        value: 1,
                    },
                    {
                        label: '会签',
                        value: 2,
                    }
                ],
                sameApproverOptions: [
                    {
                        label: '自动通过',
                        value: 1,
                    },
                    {
                        label: '人工审批',
                        value: 2,
                    }
                ],
                approvalTypeList: {
                    staff: [],
                    role: [],
                },
                handleTypeOptions: [],
                // 判断节点总条件
                judgeConditionMap: {
                    // 关联逻辑
                    link: [{
                        value: '&&',
                        label: '并且'
                    }, {
                        value: '||',
                        label: '或者'
                    }],
                    // 枚举类型比较条件
                    enumCondition: [{
                        value: '==',
                        label: '等于'
                    }, {
                        value: '!=',
                        label: '不等于'
                    }],
                    // 数字类型比较条件
                    numberCondition: [{
                        value: '==',
                        label: '等于'
                    }, {
                        value: '!=',
                        label: '不等于'
                    }, {
                        value: '>',
                        label: '大于'
                    }, {
                        value: '>=',
                        label: '大于等于'
                    }, {
                        value: '<',
                        label: '小于'
                    }, {
                        value: '<=',
                        label: '小于等于'
                    }],
                    // 字符串类型比较条件
                    stringCondition: [{
                        value: '==',
                        label: '等于'
                    }, {
                        value: '!=',
                        label: '不等于'
                    }, {
                        value: 'baohan',
                        label: '包含'
                    }, {
                        value: 'bubaohan',
                        label: '不包含'
                    }, {
                        value: 'baohanyu',
                        label: '包含于'
                    }, {
                        value: 'bubaohanyu',
                        label: '不包含于'
                    }],
                },
                // 默认的条件map
                constConditionMap: {
                    // 提交人
                    flowStartId: {
                        condition: '包含于',
                        multi: true,
                        options: []
                    },
                    departId: {
                        condition: '包含于',
                        multi: true,
                        options: []
                    },
                    roleIds: {
                        condition: '包含',
                        multi: false,
                        options: []
                    },
                },
                labelWidthMap: {
                    "approval-node": '110px',
                    'edge': '0px'
                },
                dialogTitleMap: {
                    "handle-node": '经办节点',
                    "approval-node": '审批节点',
                    "judge-node": '判定节点',
                    'edge': '分支条件'
                },
                flowDefId: 7,
                fieldList: [],
                formRulesMap: {
                    label: [
                        { required: true, message: '请输入节点名称', trigger: 'blur' },
                        { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
                    ],
                    checkMethod: [
                        {required: true, message:'请选择', trigger: 'change'}
                    ],
                    sameApprover: [
                        {required: true, message:'请选择', trigger: 'change'}
                    ],
                    handleType: [
                        {required: true, message:'请选择处理事项', trigger: 'change'}
                    ],
                },
                str: '',
                elMethod: '',
            }
        },
        computed: {
            dialogTitle() {
                return `编辑${this.dialogTitleMap[this.detailModel.type]}`
            },
        },
        methods: {
            refresh() {
                // 打开弹框时清除form的校验
                this.$refs.form.clearValidate();

                if (this.detailModel.type === 'edge') {
                    // 获取分支条件下的字段下拉
                    this.flowDefParamListApi()
                    // 获取部门数据
                    this.departmentOrgApi('constConditionMap.departId.options')
                    // 获取员工数据
                    this.userListApi('constConditionMap.flowStartId.options')
                    // 获取角色数据
                    this.rolesListApi('constConditionMap.roleIds.options')
                    // 条件预览
                    this.str = this.detailModel.data.label
                } else if (this.detailModel.type === 'approval-node') {
                    // 审批节点需要获取员工和角色列表
                    this.userListApi('approvalTypeList.staff')
                    this.rolesListApi('approvalTypeList.role')
                } else if (this.detailModel.type === 'handle-node') {
                    // 经办节点需要获取处理事项
                    this.flowDefEnumsApi()
                }
            },
            //  当字段下拉框发生改变的时候，根据字段选择的值返回条件下拉选项数组及比较对象下拉选项数组
            onConditionFieldChange: function (field, index) {
                if (!field) {
                    this.$set(this.detailModel.data.conditionData[index], 'judgeCondition', null);
                    this.$set(this.detailModel.data.conditionData[index], 'compareOptions', []);
                    return false
                }

                const currentData = this.fieldList.filter(option => {
                    return option.paramName === field
                });
                const currentItem = currentData[0];
                const paramTypeId = currentItem.paramTypeId; // 参数类型(1-数值 2-字符 3-枚举 enum.id)
                let conditionOpts = null, options, multi = false, condition = null;

                if (this.constConditionMap.hasOwnProperty(field)) {
                    condition = this.constConditionMap[field].condition;
                    options = this.constConditionMap[field].options;
                    multi = this.constConditionMap[field].multi;
                } else if (paramTypeId === 3) {
                    conditionOpts = this.judgeConditionMap.enumCondition;
                    options = currentItem.description ? JSON.parse(currentItem.description) : [];
                } else if (paramTypeId === 1) {
                    // 输入数字
                    conditionOpts = this.judgeConditionMap.numberCondition;
                    options = null;
                } else {
                    // 字符串类型
                    conditionOpts = this.judgeConditionMap.stringCondition;
                    options = null;
                }

                this.$set(this.detailModel.data.conditionData[index], 'judgeCondition', conditionOpts);
                this.$set(this.detailModel.data.conditionData[index], 'condition', condition);
                this.$set(this.detailModel.data.conditionData[index], 'compareOptions', options);
                this.$set(this.detailModel.data.conditionData[index], 'compareOptionsMulti', multi);
                this.$set(this.detailModel.data.conditionData[index], 'compareObj', null);
                this.$set(this.detailModel.data.conditionData[index], 'paramObj', currentItem);

                this.calcPreviewCondition();
            },
            handleInput: function (e) {
                if (e.keyCode === 13) {
                    return
                }
                e.target.value = (e.target.value.match(/^\d*(\.?\d{0,1})/g)[0]) || null
            },
            removeCondition: function (index) {
                this.detailModel.data.conditionData.splice(index, 1);
            },
            addCondition: function () {
                this.detailModel.data.conditionData.push({
                    link: null,
                    leftParenthesis: false,
                    field: null,
                    condition: null,
                    compareObj: null,
                    rightParenthesis: false
                });
            },
            close() {
                this.dialogFormVisible = false
                this.str = ''
                this.elMethod = ''
                this.$emit('cancel')
            },
            save() {
                // 校验逻辑
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        // 校验审批节点选项
                        if (this.detailModel.type === 'approval-node') {
                            const approvalData = this.detailModel.data.approvalData || []
                            let approvalValueArr = []
                            approvalData.forEach(item => {
                                approvalValueArr = approvalValueArr.concat(item.approvalValue)
                            })
                            if (approvalValueArr.length === 0) {
                                Ele.Message.error('编辑审批节点失败，请设置审批该节点的员工或角色')
                                return false
                            }
                        } else if (this.detailModel.type === 'edge') {
                            // 校验分支条件
                            let hasError = false
                            const dataList = this.detailModel.data.conditionData
                            const right = []
                            const left = []
                            for (let i = 0; i < dataList.length; i++) {
                                if (dataList[i].leftParenthesis) {
                                    left.push({ biao: i })
                                }
                                if (dataList[i].rightParenthesis) {
                                    right.push({ biao: i })
                                }
                                if (i > 0 && !dataList[i].link && dataList[i].field) {
                                    Ele.Message.error('编辑判定节点失败，判定条件中关联逻辑存在问题，请仔细检查并修正')
                                    hasError = true
                                    break
                                }
                                if (!dataList[i].condition && dataList[i].field) {
                                    Ele.Message.error(`编辑判定节点失败，字段【${dataList[i].paramObj.paramKey}】必须设置条件`)
                                    hasError = true
                                    break
                                }
                                if (((!dataList[i].compareObj  && dataList[i].compareObj !== 0) || (dataList[i].compareObj instanceof Array && dataList[i].compareObj.length === 0)) && dataList[i].field) {
                                    Ele.Message.error(`编辑判定节点失败，字段【${dataList[i].paramObj.paramKey}】必须设置比较对象`)
                                    hasError = true
                                    break
                                }
                            }

                            if (hasError) {
                                return false
                            }

                            // 判断括号-数量
                            if (right.length !== left.length) {
                                Ele.Message.error('编辑判定节点失败，判定条件中括号存在问题，请仔细检查并修正')
                                return false
                            }
                            // 判断括号-关联关系
                            for (let i = 0, j = right.length; i < j; i++) {
                                if (right[i].biao < left[i].biao) {
                                    hasError = true
                                    break
                                }
                            }
                            if (hasError) {
                                Ele.Message.error('编辑判定节点失败，判定条件中括号存在问题，请仔细检查并修正')
                                return false
                            }

                            console.log(1111, this.str)
                            console.log('表达式：', '${' + this.elMethod + '}')
                            console.log('表单内容：', dataList)
                            this.detailModel.data.label = this.str
                            this.detailModel.data.elMethon = this.elMethod
                            this.detailModel.data.previewStr = this.str
                        }
                        this.$emit('save')
                    } else {
                        return false;
                    }
                });
            },
            // 获取字段接口
            async flowDefParamListApi() {
                const res = await flowDefParamList(this.flowDefId)
                if (res.code === 0) {
                    this.fieldList = res.data || []
                }
            },
            // 获取部门
            async departmentOrgApi(dataKey) {
                const res = await departmentOrg()
                if (res.code === 0) {
                    set(this, dataKey, res.data || [])
                }
            },
            // 获取用户
            async userListApi(dataKey) {
                const res = await getUserList()
                if (res.code === 0) {
                    set(this, dataKey, res.data || [])
                }
            },
            // 获取角色
            async rolesListApi(dataKey) {
                const res = await getRolesList()
                if (res.code === 0) {
                    set(this, dataKey, res.data || [])
                }
            },
            // 获取处理事项
            async flowDefEnumsApi() {
                const res = await flowDefEnums(this.flowDefId)
                if (res.code === 0) {
                    this.handleTypeOptions = res.data || []
                }
            },
            // 计算条件预览
            calcPreviewCondition () {
                if (!this.detailModel.data.conditionData || !(this.detailModel.data.conditionData instanceof Array)) {
                    return false
                }

                let linkMap = {}
                this.judgeConditionMap.link.forEach(item => {
                    linkMap[item.value] = item.label
                })
                this.str = ''
                this.elMethod = ''
                this.detailModel.data.conditionData.map(item => {
                    let userStr = ''
                    let userIdStr = ''
                    let baohanyuStr = ''
                    if (item.compareObj) {
                        if (Array.isArray(item.compareObj) && item.compareObj.length > 0) {
                            // 多选的提交人和提交人部门
                            if (this.constConditionMap.hasOwnProperty(item.field)) {
                                // 全部的选项
                                const options = this.constConditionMap[item.field].options;
                                // 被选中的选项
                                const checkedArr = options.filter(opt => item.compareObj.includes(opt.id))
                                userStr = checkedArr.map(i => i.name).join('、')
                                userIdStr = checkedArr.map(i => i.id).join('、')
                            }
                        } else {
                            // 枚举类型
                            if (item.paramObj.paramTypeId === 3 && item.paramObj.description.length > 0) {
                                // 全部的选项
                                const options = JSON.parse(item.paramObj.description);
                                // 被选中的选项
                                const checkedArr = options.filter(opt => item.compareObj === opt.id)
                                userStr = checkedArr.map(i => i.name).join('、')
                                userIdStr = checkedArr.map(i => i.id).join('、')
                            } else if (item.field === 'roleIds') {
                                // 单选的提交人角色
                                const options = this.constConditionMap[item.field].options;
                                for (let i = 0, j = options.length; i < j; i++) {
                                    if (options[i].id === item.compareObj) {
                                        userStr += options[i].name
                                        userIdStr += options[i].id
                                        break
                                    }
                                }
                            } else {
                                userIdStr = userStr = item.compareObj
                            }
                        }
                    }
                    // 关联关系
                    const linkName = item.link ? linkMap[item.link] : ''

                    // 比较条件
                    let conditionName = ''
                    if (item.judgeCondition != null && item.judgeCondition instanceof Array ) {
                        const conditionOptions = item.judgeCondition
                        for (let i = 0, j = conditionOptions.length; i < j; i++) {
                            if (conditionOptions[i].value === item.condition) {
                                conditionName = conditionOptions[i].label
                                break
                            }
                        }
                    } else {
                        conditionName = item.condition
                    }

                    // 条件预览
                    this.str += `${linkName} ${item.leftParenthesis ? '(' : ''} ${item.field ? item.paramObj.paramKey : ''}` +
                        ` ${conditionName ? conditionName : ''} ${userStr || ''} ${item.rightParenthesis ? ')' : ''}`

                    // 组建el表达式
                    switch (item.condition) {
                        case 'baohanyu':
                        case '包含于':
                            baohanyuStr = `'${userIdStr}'.contains(${item.field ? item.field : ''})`
                            break;
                        case 'bubaohanyu':
                            baohanyuStr = `!'${userIdStr}'.contains(${item.field ? item.field : ''})`
                            break;
                        case 'baohan':
                        case '包含':
                            baohanyuStr = `${item.field ? item.field : ''}.contains('${userIdStr}')`
                            break;
                        case 'bubaohan':
                            baohanyuStr = `!${item.field ? item.field : ''}.contains('${userIdStr}')`
                            break;
                        default:
                            baohanyuStr = `${item.field ? item.field : ''}${item.condition}'${userIdStr}'`
                            break;
                    }
                    this.elMethod += ` ${item.link ? item.link : ''} ${item.leftParenthesis ? '(' : ''}${baohanyuStr}${item.rightParenthesis ? ')' : ''}`
                })
                this.str = this.str.trim()
                this.elMethod = this.elMethod.trim()
            }
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
</style>
